import React from 'react';
import { Controller } from 'react-hook-form';
import { Radio as AntRadio, RadioProps, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import InfoCircleIcon from '../Icons/InfoCircleIcon';
import HelpInfo from './HelpInfo';
import { useHover } from 'hooks';

interface Props extends RadioProps {
  control: any;
  inputName: string;
  error?: any;
  helpInfo?: string[];
  callback?: () => void;
  options: {
    key: string | number | boolean;
    label: string | JSX.Element;
    disabled?: boolean;
    img?: JSX.Element;
    title?: string;
  }[];
  defaultValue: any;
}

export default function Radio({
  control,
  inputName,
  options,
  defaultValue,
  error,
  helpInfo = [],
  callback = () => {},
  ...props
}: Props) {
  const { t } = useTranslation();
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);
  return (
    <Controller
      control={control}
      name={inputName}
      // rules={rules}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <div className={`custom-input`} style={{ position: 'relative' }}>
          <AntRadio.Group
            {...props}
            value={value}
            onChange={e => {
              callback();
              onChange(e.target.value);
            }}
            className={'custom-radio custom-input'}
            size={'large'}
          >
            {options.map(option => (
              <AntRadio
                key={`${option.key}`}
                value={option.key}
                disabled={option.disabled}
              >
                <span
                  className={
                    props.disabled
                      ? 'custom-radio-label-disabled'
                      : 'custom-radio-label'
                  }
                >
                  {' '}
                  {option.label}
                </span>
              </AntRadio>
            ))}
          </AntRadio.Group>
          <div style={{ position: 'absolute', top: 7, right: 7 }}>
            <Tooltip
              title={t(error?.message) || <HelpInfo helpInfo={helpInfo} />}
              overlayClassName={
                error?.message ? 'error-tooltip' : 'help-tooltip'
              }
              placement="topRight"
              color={''}
              arrowPointAtCenter
              trigger={
                window.matchMedia('(any-pointer: coarse)').matches
                  ? 'click'
                  : 'hover'
              }
            >
              <div style={{ display: 'flex' }} ref={hoverRef}>
                {error?.message ? (
                  <InfoCircleIcon />
                ) : helpInfo.length > 0 ? (
                  <InfoCircleIcon type="help" isHover={isHover} />
                ) : null}
              </div>
            </Tooltip>
          </div>
        </div>
      )}
    />
  );
}
